import { html } from 'lit-element';
import { getItemContentAndValue } from '../../fc-form-field-helper.js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { ifDefined } from 'lit-html/directives/if-defined';
/* eslint-disable camelcase, no-invalid-this */
/**
 * Render: Select
 * @return {*}
 */

const render_select = function() {
  const {
    options,
    value,
    disabled,
    placeholder,
    label,
    required,
    extended,
    warning
  } = this;
  const slottedOptions = Array.from(this.querySelectorAll('option'));
  const isSlottedOptions = slottedOptions.length;
  return html`
    <fc-select 
      ?extended="${ifDefined(extended)}"
      ?required="${required}" 
      .list=${ifDefined(options)} 
      ?disabled=${disabled} 
      placeholder='${placeholder || 'Select Option'}' 
      label=${ifDefined(label)}
      warning=${ifDefined(warning)}
      value=${ifDefined(value)} 
      @select=${event => this.setValue(event.detail.value)}>
      ${isSlottedOptions ? slottedOptions.map(select => {
    const { itemValue, itemContent } = getItemContentAndValue(select);
    return html`<option value=${itemValue}>${unsafeHTML(itemContent)}</option>`;
  }) : null}
    </fc-select>
  `;
};

export { render_select };
// # sourceMappingURL=form-render_select-field.js.map
